import { ReferenceField, TextField, useRecordContext } from "react-admin";
import { ConstructionSiteMeta } from "./ConstructionSiteMeta";
import { ConstructionSiteQuickActions } from "./ConstructionSiteQuickActions";
import { joinAddressLine } from "../components/raFormat";
import {
  AppShow,
  AppShowActions,
  AppShowCard,
  AppShowContent,
  AppShowSection,
  AppShowSectionHeader,
  AppShowField,
  AppShowTextField,
} from "@/adapters/inbound/layout";

export const ConstructionSiteShow = () => (
  <AppShow actions={<AppShowActions />} aside={<ConstructionSiteMeta />}>
    <AppShowCard>
      <AppShowContent>
        <AppShowSection>
          <AppShowSectionHeader
            title="Einsatzort"
            subtitle="Bezeichnung und Kundenzuordnung."
          />
          <AppShowTextField source="label" label="Bezeichnung" emptyText="—" />

          <AppShowField label="Kunde">
            <ReferenceField
              source="clientId"
              reference="clients"
              link="show"
              label={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </AppShowField>
        </AppShowSection>

        <AppShowSection>
          <AppShowSectionHeader
            title="Adresse"
            subtitle="Standort des Einsatzortes."
          />
          <AppShowField label="Adresse">
            <ReferenceField
              source="addressId"
              reference="addresses"
              link="show"
              label={false}
            >
              <ConstructionSiteAddressField />
            </ReferenceField>
          </AppShowField>

          <AppShowField label="Aktionen">
            <ReferenceField
              source="addressId"
              reference="addresses"
              link={false}
              label={false}
            >
              <ConstructionSiteActionsField />
            </ReferenceField>
          </AppShowField>
        </AppShowSection>
      </AppShowContent>
    </AppShowCard>
  </AppShow>
);

function ConstructionSiteAddressField() {
  const address = useRecordContext<any>();
  if (!address) return null;
  return <>{joinAddressLine(address)}</>;
}

function ConstructionSiteActionsField() {
  const address = useRecordContext<any>();
  if (!address) return null;
  return <ConstructionSiteQuickActions address={address} />;
}
